<ng-template [ngIf]="animate">
  <input class="checkbox__input" id="open" type="checkbox" />
  <label class="checkbox__label" for="open" (click)="focusSearchInput()">
    <img class="search__confirm" src="assets/images/search.svg" alt="Buscar" />
  </label>
</ng-template>

<div class="search" [ngClass]="{ 'animation-initial': animate }">
  <form class="search__inner">
    <input
      (keyup.enter)="onEnterOrSearchKeyPressed()"
      #searchInput
      type="search"
      class="search__input dark mapfre-fs-xs-r"
      (input)="onTyping()"
      (focus)="onFocus()"
      [placeholder]="placeholder"
      [formControl]="textSearched"
    />
    <img
      class="search__reset"
      *ngIf="isTyping"
      (click)="onReset()"
      src="assets/images/header/close.svg"
      alt="Resetear búsqueda"
    />
    <img
      class="search__confirm"
      (click)="onSearchButton()"
      src="assets/images/search.svg"
      alt="Buscar"
    />
  </form>
</div>
